import { getStorageItem } from "./utils";

export const buildUpdateCustomerDetails = (
  form,
  selectedOccupationOption,
  terminated = false
) => {
  const {
    alcohol,
    annual_income: annualIncome,
    education,
    einsurance_account: eInsurance,
    einsurance_account_open: eInsuranceAccountOpen,
    einsurance_account_number: eInsuranceAccount,
    einsurance_repository: eInsuranceRepo,
    father_name: fatherName,
    income_tax_proof: incomeTaxProof,
    marital_status: maritalStatus,
    organisation_name: organisationName,
    pan_number: panNumber,
    sector,
    smoker,
  } = form;

  const payload = buildCommonPayload(form, selectedOccupationOption);

  return terminated
    ? payload
    : {
        ...payload,
        alcohol,
        annualIncome,
        education,
        eInsurance,
        eInsuranceAccount: eInsurance === "Yes" ? eInsuranceAccount : "",
        eInsuranceAccountOpen,
        eInsuranceRepo: eInsuranceAccountOpen === "Yes" ? eInsuranceRepo : "",
        fatherName,
        incomeTaxProof,
        sector,
        smoker,
        maritalStatus,
        organisationName,
        panNumber,
      };
};

export const buildCommonPayload = (
  { occupation_type, self_employee_type },
  { label, code, risk_categorization }
) => {
  return {
    cid: Number(getStorageItem("cid")),
    occupation: occupation_type,
    occupationCode: code,
    occupationName: label,
    riskCategory: risk_categorization,
    selfEmployedType:
      occupation_type === "Self-Employed" ? self_employee_type : null,
  };
};

export const buildVerifyPancardPayload = ({ pan_number }, checksum) => {
  return {
    checksum,
    cid: Number(getStorageItem("cid")),
    oid: Number(getStorageItem("oid")),
    pan: pan_number.toUpperCase(),
  };
};
